import React from 'react';
// import { VisibilityKey } from '../constants/tabConfig';
type VisibilityKey = 'announcements' | 'assignments' | 'discussions' | 'files' | 'modules' | 'pages' | 'enrollments' | 'quizzes'|'syllabus' ;


interface ToggleSwitchProps {
  label: string;
  visibility: { [key in VisibilityKey]: boolean };
  handleToggleChange: (key: VisibilityKey, courseId: number ) => void;
  tab: VisibilityKey;
  courseId: number;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ label, visibility, handleToggleChange, tab, courseId }) => {
  const isToggled = visibility[tab]; // Get the visibility for the tab

  return (
    <div className="flex justify-end items-center mb-4">
      <label className="mr-2 text-gray-700 text-sm">{label}:</label>
      <div
        onClick={() => handleToggleChange(tab, courseId)} // Toggle visibility for the specific course and tab
        className={`relative inline-flex items-center cursor-pointer w-10 h-5 rounded-full mr-4 ${isToggled ? 'bg-black' : 'bg-gray-300'}`}
      >
        <span className={`w-4 h-4 bg-white rounded-full transition-all duration-300 transform ${isToggled ? 'translate-x-5' : 'translate-x-0'}`}></span>
      </div>
    </div>
  );
};


export default ToggleSwitch;
